export default function expand(btnElement) {
	var btn = $(btnElement);

	btn.on('click', function() {
		let bodyToToggle = $(this).siblings('.to-toggle'),
			curHeight = bodyToToggle.height(),
			autoHeight = bodyToToggle.css('height', 'auto').height();

		if (curHeight === 0) {
			bodyToToggle.height(curHeight).animate({ height: autoHeight }, 300);
			btn.find('a').html('collapse <i class="fa fa-chevron-up">');
		} else {
			bodyToToggle.height(curHeight).animate({ height: 0 }, 300);
			btn.find('a').html('expand <i class="fa fa-chevron-down">');
		}
	});
}
